import React, { Component } from 'react';
import { Icon, Button, Modal, Table, Form, Input, Checkbox, Tag, message, Tooltip, Select } from 'antd';
import { getRoomList, getAffiliatedHospitelList, deleteRoom, getAddRoomInfo, deptSelect } from '@/request/api'
import { requestErrorLog } from '@/common/util'

const { confirm } = Modal;
const { Option } = Select;
class SettingRoom extends Component {

  constructor(props) {
    super(props);
    this.state = {
      rowData: "",
      tableList: [],
      hospitalData: [],
      userHosDept: [],
      deptSelect: [],
      roomCode: "",
      roomName: "",
      RoomColumns: [
        {
          title: '所属医院',
          dataIndex: 'HOSPITAL_UID',
          key: 'HOSPITAL_UID',
          width: 200,
          render: (text) => {
            return this.state.hospitalData.map((item, index) => {
              const a = item.HOSPITAL_UID === text ? item.HOSPITAL_NAME : null
              // return <Popover overlayStyle={{ width: '200px' }} key={index} content={<span style={{ color: '#333' }}>{a}</span>}><span>{a}</span></Popover>
              return <Tooltip placement="topLeft" title={a}> <span>{a}</span>  </Tooltip>
            });
          }
        },
        {
          title: '所属科室',
          dataIndex: 'DEPT_NAME',
          key: 'DEPT_NAME',
          width: 250
        },
        {
          title: '房间编码',
          dataIndex: 'ROOM_CODE',
          key: 'ROOM_CODE',
          width: 320
        },
        {
          title: '房间名称',
          dataIndex: 'ROOM_NAME',
          key: 'ROOM_NAME',
          width: 220
        },
        {
          title: '可用',
          dataIndex: 'IS_ENABLED',
          key: 'IS_ENABLED',
          render: (text) => {
            return text ? '可用' : '不可用'
          }
        }
      ],
      PageNo: 1,
      PageSize: 10,
      RowCount: 0,
    };
  }

  componentDidMount() {
    this.handleRoomList()
    this.hospitalList()
  }

  hospitalList = () => { // 获取医院列表
    getAffiliatedHospitelList().then((res) => {
      if (res && res.Status === 1) {
        const data = res.Result
        this.setState({
          hospitalData: data,
        })
      } else {
        requestErrorLog('', '权限管理-房间管理-获取医院列表报错', 0, true)
      }
    })
  }

  handleRoomList = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "ROOMSELECT", // 房间管理列表
      ROOM_CODE: this.state.roomCode,
      ROOM_NAME: this.state.roomName,
      HOSPITAL_UID: userInfo.HOSPITAL_UID,
      PageNo: this.state.PageNo,
      PageSize: this.state.PageSize,
    }
    getRoomList(params).then((res) => {
      if (res && res.Status === 1) {
        const dataList = res.Result.dataInfo;
        let RowCount = res.Result.pageInfo.RowCount
        this.setState({
          tableList: dataList,
          RowCount
        });
      } else {
        requestErrorLog('', '权限管理-房间管理-获取房间管理列表报错', 0, true)
      }
    });
  }

  handleRoomAdd = () => { // 新增
    this.props.form.resetFields(); //清空form中每条数据
    this.setState({
      isModalVisible: true,
      modalTitle: "ROOM_INFOADD",
      rowData: ""
    });
    let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.handleSelectUserHos(null, userInfo.HOSPITAL_UID)
  };

  handleRoomEdit = () => { // 修改
    this.props.form.resetFields(); //清空form中每条数据
    if (this.state.rowData) {
      this.setState({
        isModalVisible: true,
        modalTitle: "ROOM_INFOEDIT",
      });
      this.handleSelectUserHos(null, this.state.rowData.HOSPITAL_UID)
    } else {
      message.warning('请先选择要操作的数据');
    }
  };

  handleRoomDelete = () => { // 删除
    const { rowData } = this.state;
    if (!rowData) {
      message.warning("请先选择要操作的数据");
    } else {
      confirm({
        title: "删除操作",
        content: "确认删除该房间信息吗？",
        onOk: () => {
          let params = {
            Type: "ROOM_INFODELETE",
            ROOM_UID: rowData.ROOM_UID,
          }
          deleteRoom(params).then((res) => {
            if (res && res.Status === 1) {
              message.success("删除成功！");
              this.handleRoomList();
              this.setState({ rowData: '' })
            } else {
              requestErrorLog('', '权限管理-房间管理-删除房间报错', 0, true)
              message.error("删除失败！");
            }
          });
        },
      });
    }
  }

  handleRoomSubmit = () => {
    const { modalTitle, rowData } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
        let params = { Type: modalTitle, HOSPITAL_CODE: userInfo.HOSPITAL_CODE }
        let RequestModel = {
          ROOM_UID: modalTitle === 'ROOM_INFOEDIT' ? rowData.ROOM_UID : '',
          ROOM_CODE: values.ROOM_CODE,  //房间编码
          ROOM_NAME: values.ROOM_NAME,  //房间名称
          HOSPITAL_UID: values.HOSPITAL_UID,  //医院UID
          DEPT_UID: values.DEPT_UID,  // 部门代码
          IS_ENABLED: values.IS_ENABLED ? 1 : 0,  // 标识(0:不可用 1:可用)
        }
        getAddRoomInfo(params, RequestModel).then((res) => {
          if (res && res.Status === 1) {
            if (res.Result === -2) {
              message.error("房间名称不能相同！")
            }
            this.setState({
              isModalVisible: false,
              rowData: ''
            });
            this.handleRoomList();
            modalTitle === 'ROOM_INFOADD' ? message.success("新建成功") : message.success("修改成功！")
          } else {
            requestErrorLog('', '权限管理-房间管理-' + modalTitle === 'ROOM_INFOADD' ? '新建房间报错' : '编辑房间报错', 0, true)
            this.handleRoomList();
            modalTitle === 'ROOM_INFOADD' ? message.error("新建失败") : message.error("修改失败！")
          }
        });
      }
    });
  };


  onClickRow = (record) => {
    return {
      onClick: () => {
        this.setState({
          rowData: record,
        });
      },
    };
  };

  setRowClassName = (record) => {
    return record === this.state.rowData ? "clickRowStyl" : "";
  };

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
    });
  };

  handleRoomName = (e) => {
    this.setState({
      roomName: e.target.value
    })
  }
  handleRoomCode = (e) => {
    this.setState({
      roomCode: e.target.value
    })
  }

  //页码改变
  changePageFn = (PageNo) => {
    this.setState({
      PageNo,
    }, () => {
      this.handleRoomList()
    })
  }
  searchRoomFn = () => {
    this.setState({
      PageNo: 1,
      PageSize: 10,
    }, () => {
      this.handleRoomList()
    })
  }

  // 切换医院时 科室清空
  changeHosToDept = (value, option) => {
    this.props.form.setFieldsValue({
      "DEPT_UID": undefined,
    });

    this.handleSelectUserHos(value, option.key);
  }

  handleSelectUserHos = (value, option) => { // 获取系统科室
    let params = {
      "Type": "DeptSelect",
      "HOSPITAL_UID": option
    }
    deptSelect(params).then((res) => {
      if (res && res.Status === 1) {
        const data = res.Result;
        this.setState({
          userHosDept: data
        })
      } else {
        requestErrorLog('', '权限管理-房间管理-获取系统科室报错', 0, true)
      }
    })
  }


  render() {
    const { getFieldDecorator } = this.props.form;
    const { isModalVisible, modalTitle, RoomColumns, tableList, rowData, hospitalData } = this.state;
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    const roleList = JSON.parse(localStorage.getItem('roleList')) || {}
    return (
      <>
        <div className="btnStyle" style={{ marginBottom: "10px" }}>
          <Button onClick={this.handleRoomAdd}>
            <Icon type="plus-circle" />
            添加
          </Button>
          <Button onClick={this.handleRoomEdit}>
            <Icon type="minus-circle" />
            修改
          </Button>
          <Button onClick={this.handleRoomDelete}>
            <Icon type="close-circle" />
            删除
          </Button>
        </div>

        <Form layout="inline">
          <Form.Item label="所属医院">
            <Tag color="cyan" style={{ fontSize: 15 }}>{userInfo.HOSPITAL_NAME}</Tag >
          </Form.Item>
          <Form.Item label="房间编码">
            {getFieldDecorator("roomCode")(<Input allowClear={true} onChange={this.handleRoomCode} />)}
          </Form.Item>
          <Form.Item label="房间名称">
            {getFieldDecorator("roomName")(<Input allowClear={true} maxLength={15} onChange={this.handleRoomName} />)}
          </Form.Item>
          <Button onClick={this.searchRoomFn}>查询</Button>
        </Form>

        <Table
          columns={RoomColumns}
          dataSource={tableList}
          rowKey={(record) => record.ROOM_UID}
          pagination={{
            total: this.state.RowCount,
            current: this.state.PageNo,
            onChange: this.changePageFn
          }}
          onRow={this.onClickRow}
          rowClassName={this.setRowClassName}
        />
        <Modal
          title={
            <div className="patient_title">
              <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
              <span>{modalTitle === "ROOM_INFOADD" ? "添加房间" : "编辑房间"}</span>
            </div>
          }
          visible={isModalVisible}
          maskClosable={false}
          onOk={this.handleRoomSubmit}
          onCancel={this.handleCancel}
        >
          <Form layout="inline">
            {modalTitle === 'ROOM_INFOEDIT' ?
              <Form.Item label="房间编码">
                {getFieldDecorator('ROOM_CODE', { initialValue: rowData.ROOM_CODE })(<Input disabled style={{ width: '260px' }} />)}
              </Form.Item> : null
            }

            <Form.Item label="房间名称">
              {getFieldDecorator('ROOM_NAME', { initialValue: rowData.ROOM_NAME, rules: [{ required: true, message: '房间名称不能为空' }] })(<Input maxLength={15} allowClear={true} style={{ width: '260px' }} />)}
            </Form.Item>
            {userInfo.IS_ADMINISTRATOR || roleList.indexOf('二级管理员') > -1 ?
              <Form.Item label="所属医院" className="settingHospitalRequire">
                {getFieldDecorator('HOSPITAL_UID', { initialValue: modalTitle === 'ROOM_INFOEDIT' ? rowData.HOSPITAL_UID : '' })(
                  <Select
                    style={{ width: '200px' }}
                    onChange={this.changeHosToDept}
                    showSearch
                    optionFilterProp="children"
                  >
                    {
                      hospitalData.map((item) => (
                        <Option key={item.HOSPITAL_UID} value={item.HOSPITAL_UID}>{item.HOSPITAL_NAME}</Option>
                      ))
                    }
                  </Select>
                )}
              </Form.Item> : null
              // <Form.Item label="所属医院" className="settingHospitalRequire">
              //   {getFieldDecorator('HOSPITAL_UID', { initialValue: modalTitle === 'ROOM_INFOEDIT' ? rowData.HOSPITAL_UID : '' })(
              //     <Select style={{ width: '200px' }} disabled>
              //       {
              //         hospitalData.map((item) => (
              //           <Option key={item.HOSPITAL_UID} value={item.HOSPITAL_UID}>{item.HOSPITAL_NAME}</Option>
              //         ))
              //       }
              //     </Select>
              //   )}
              // </Form.Item>
            }
            <Form.Item label="所属科室" className="settingHospitalRequire">
              {getFieldDecorator('DEPT_UID', { rules: [{ required: true, message: '请选择您所在的科室' }], initialValue: modalTitle === 'ROOM_INFOEDIT' ? rowData.DEPT_UID : undefined })(
                <Select
                  style={{ width: '200px' }}
                  placeholder="请选择科室"
                  getPopupContainer={triggerNode => triggerNode.parentNode}
                  showSearch
                  optionFilterProp="children"
                >
                  {
                    this.state.userHosDept.map((item) => (
                      <Option key={item.DEPT_UID} value={item.DEPT_UID}>{item.DEPT_NAME}</Option>
                    ))
                  }
                </Select>
              )}
            </Form.Item>
            <Form.Item label="是否有效">
              {getFieldDecorator('IS_ENABLED', { valuePropName: 'checked', initialValue: (modalTitle === 'ROOM_INFOEDIT' && rowData) ? rowData.IS_ENABLED : true })(
                <Checkbox style={{ width: '260px' }}>有效</Checkbox>
              )}
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  }
}
export default Form.create({})(SettingRoom);